module.exports = function getZone (projection) {
    return Number.parseInt(projection.toString().substring(3));
};


// WEBPACK FOOTER //
// ./node_modules/utm-utils/src/getZone.js